export enum ProductCategoryTypeEnum {
    PRINTER,
    MFC,
    SCANNER,
    LABELER,
    FAX,
    ACCESSORY,
    SUPPLY,
    WARRANTY,
    OTHER,
    EOL,
    SERVICE,
    UPGRADE
}
